import React, {useState} from 'react';
import {
    Button,
    CardText,
    Col,
    Modal,
    ModalBody,
    ModalHeader,
    Row,
    Spinner
} from "reactstrap";
//import toast from "react-hot-toast";
//import axios from "axios";

const DeleteProducService = ({isOpen, handleClose, item, itemList, setItem}) => {

    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {

        setLoading(true);
        //const res = await axios.delete(`${process.env.REACT_APP_API_URL}/areas/${item.areaId}`);

        handleClose(false);
        const itemSelected = item
        console.log("itemSelected: ", itemSelected)
        const newData = itemList.filter(item => item.id !== itemSelected.id);
        console.log("newData: ", newData)

        setItem(newData)
        /*if (res.data.header.code === 200) {
            toast.success('Area eliminada con exito');
            setTimeout(() => window.location.reload(), 1000);
        }

        if (res.data.header.code === 500){
            toast.error(res.data.header.message);
        }*/

        setLoading(false);

    }

    return (
        <Modal isOpen={isOpen} toggle={() => handleClose(false)} className='modal-dialog-centered modal-lg'>
            <ModalHeader className='bg-transparent' toggle={() => handleClose(false)}></ModalHeader>
            <ModalBody className='px-sm-5 mx-50 pb-5'>
                <div className='text-center mb-2'>
                    <h1 className='mb-1'>Eliminar registro</h1>
                </div>
                {loading ? <Row>
                    <div className='col-12 px-2 py-4 text-center'>
                        <Spinner size='lg'/>
                        <CardText className={'py-1 fs-5'}>Eliminando registro...</CardText>
                    </div>
                </Row> : <Row className='gy-1 pt-75'>
                    <Col md={12} xs={12} className={'text-center'}>
                        <p>Esta seguro de eliminar este registro?</p>
                    </Col>
                    <Col xs={12} className='text-center mt-2 pt-50'>
                        <Button type='button'
                                onClick={handleDelete}
                                className='me-1' color='danger' disabled={!item}>
                            Eliminar
                        </Button>
                        <Button type='reset' color='secondary' outline onClick={() => handleClose(false)}>
                            Cancelar
                        </Button>
                    </Col>
                </Row>}

            </ModalBody>
        </Modal>
    );
};

export default DeleteProducService;
